export const DATA_GRID_CONFIG = {
  width: "100%",

  height: "clamp(480px, calc(100vh - 300px), 820px)",

  rowHeight: 48,

  columnHeaderHeight: 52,

  density: "standard",

  pageSize: 10,

  pageSizeOptions: [10, 25, 50],

  borderRadius: 3,

  colors: {
    border: "#e0e0e0",
    header: "#f5f7fa",
    hover: "#f1f7fe",
  },
};